<template>
  <div class="article_section">
    <h1 class="title">{{article.title}}</h1>
    <div class="article-body article-body_vpn" v-html="article.body" data-external="articles"></div>
  </div>
</template>

<script>
import { getSpecificArticleFromStore, replaceMaHcLoginSupportContent } from '@/utils/common';
export default {
  props: ['articleIdProp'],
  data() {
    return {
      articleId: ''
    };
  },
  created() {
    if (!this.articleIdProp) {
      this.fetchIdFromHash();
      return;
    }
    this.articleId = this.articleIdProp;
  },
  updated() {
    replaceMaHcLoginSupportContent(this.articleId);
  },
  methods: {
    fetchIdFromHash() {
      let hash = this.$route.hash;
      let hashSplit = this.$route.hash.split('#');

      if (!hash || hashSplit.length <= 0) {
        this.$router.push('home');
      }
      this.articleId = hashSplit[1].split('-')[0];
    }
  },
  computed: {
    article() {
      return getSpecificArticleFromStore(this.articleId) || '';
    }
  },
  watch: {
    '$route.hash'() {
      this.fetchIdFromHash();
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/styles/trusted_vpn-design.scss';
div.article-body {
  font-size: 16px;
  color: #18214F;
  font-family: 'Open Sans', sans-serif;

  p {
    font-size: 16px;
  }
  ul, ol {
    font-size: 16px;
  }
}
.article_section {
  .title {
    margin-bottom: 1rem;
    font-size: 32px;
    font-family: 'Montserrat', sans-serif;
    font-style: italic;
    font-weight: 700;
    color: #18214F;
  }
}
.article-body a {
  color: #3E3EFF !important;
  font-weight: 400;
  text-decoration: none;
}
</style>
